// extracted by mini-css-extract-plugin
export default {"field":"StudentPersonalDetailsSkeleton__field___H5Yp3"};